import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { AuditRepository } from "../repositories/AuditRepository";
import { useEffect, useState } from "react";
import moment from "moment";

export const AppEntryAuditLog = ({ appEntryId, handleClose }) => {
  const [revisions, setRevisions] = useState();
  const [showDiff, setShowDiff] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (appEntryId) {
      loadRevisions();
    }
  }, [appEntryId]);

  const loadRevisions = () => {
    setLoading(true);
    AuditRepository.getRevisions(appEntryId)
      .then((data) => {
        setRevisions(data.data);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleShowDiff = (first, second) => {
    AuditRepository.compareRevisions(
      appEntryId,
      first[3],
      second ? second[3] : null
    )
      .then((data) => {
        console.log(data.data);
        setShowDiff(
          diffObjects(data.data.firstRevision, data.data.secondRevision)
        );
        console.log(
          diffObjects(data.data.firstRevision, data.data.secondRevision)
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function diffObjects(obj1, obj2, path = "") {
    const differences = [];

    const isObject = (v) => v && typeof v === "object" && !Array.isArray(v);
    const keys = new Set([
      ...Object.keys(obj1 || {}),
      ...Object.keys(obj2 || {}),
    ]);

    for (const key of keys) {
      const fullPath = path ? `${path}.${key}` : key;
      const val1 = obj1 ? obj1[key] : undefined;
      const val2 = obj2 ? obj2[key] : undefined;

      if (Array.isArray(val1) && Array.isArray(val2)) {
        if (val1.length !== val2.length) {
          differences.push({
            path: fullPath,
            type: "array-length",
            val1,
            val2,
          });
        }
        val1.forEach((v, i) => {
          if (JSON.stringify(v) !== JSON.stringify(val2[i])) {
            differences.push({
              path: `${fullPath}[${i}]`,
              type: "array-diff",
              val1: v,
              val2: val2[i],
            });
          }
        });
      } else if (isObject(val1) && isObject(val2)) {
        differences.push(...diffObjects(val1, val2, fullPath));
      } else if (val1 !== val2) {
        differences.push({ path: fullPath, type: "value", val1, val2 });
      }
    }

    return differences;
  }

  return (
    <>
      {showDiff && (
        <Dialog
          open={showDiff != null}
          onClose={() => setShowDiff()}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Разлики помеѓу ревизии</DialogTitle>
          <DialogContent>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Патека</TableCell>
                  <TableCell>Стара вредност</TableCell>
                  <TableCell>Нова вредност</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {showDiff.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: "center" }}>
                      Нема разлики
                    </TableCell>
                  </TableRow>
                )}
                {showDiff &&
                  showDiff.length > 0 &&
                  showDiff?.map((diff, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <TableCell>{diff.path}</TableCell>
                      <TableCell>
                        {diff.val2 !== undefined
                          ? JSON.stringify(diff.val2)
                          : "/"}
                      </TableCell>
                      <TableCell>
                        {diff.val1 !== undefined
                          ? JSON.stringify(diff.val1)
                          : "/"}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowDiff()}>Затвори</Button>
          </DialogActions>
        </Dialog>
      )}
      {!showDiff && !loading && (
        <Dialog
          open={appEntryId != null}
          onClose={() => handleClose()}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Историјат на промени</DialogTitle>
          <DialogContent>
            {!loading && revisions && (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Време на настанот</b>
                    </TableCell>
                    <TableCell>
                      <b>Тип на настан</b>
                    </TableCell>
                    <TableCell>
                      <b>Корисник</b>
                    </TableCell>
                    <TableCell>
                      <b>Број на ревизија</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>Акции</b>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {revisions?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} style={{ textAlign: "center" }}>
                        Нема записи
                      </TableCell>
                    </TableRow>
                  )}
                  {revisions &&
                    revisions.length > 0 &&
                    revisions?.map((log, index) => (
                      <TableRow
                        key={log.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                        }}
                      >
                        <TableCell>
                          {log[4]
                            ? moment(log[4]).format("DD.MM.YYYY HH:mm:ss")
                            : "/"}
                        </TableCell>
                        <TableCell>{log[1]}</TableCell>
                        <TableCell>{log[2]}</TableCell>
                        <TableCell>{log[3]}</TableCell>
                        <TableCell align="center">
                          <Button
                            size="small"
                            style={{
                              fontSize: "12px",
                            }}
                            variant="contained"
                            onClick={() => {
                              if (index === 0) {
                                handleShowDiff(revisions[0], null);
                              } else
                                handleShowDiff(
                                  revisions[index],
                                  revisions[index - 1]
                                );
                            }}
                          >
                            Прикажи промени
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClose()}>Затвори</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
